/*
 *  TTTech nerve-management-system
 *  Copyright(c) 2019. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */
export default class ConnectionScreenModel {
  /**
   * Creates an instance of Connection screen Model.
   * @param {Array} data
   * @class ConnectionScreenModel
   * @property {string} id - Connection id
   * @property {string} name - Connection name
   * @property {string} location - Conection location
   * @property {string} connection - Connection type
   * @property {number} numberOfConnections - Number of connection
   * @property {string} acknowledgment - Local acknowledgment
   * @property {String} hostname - hostname
   * @property {number} port - port on node
   * @property {number} localPort - local port
   * @property {number} autoretry -autoretry
   * @property {boolean} swapRedBlue -swap red blue
   * @property {string} cursor - cursor
   * @property {boolean} readOnly - read only
   * @property {string} username - username
   * @property {string} password - password
   * @property {string} type - type
   * @property {string} privateKey - private key
   * @property {string} securityMode - security mode
   * @property {boolean} ignoreServerCertificate - ignore server certificate
   * @property {boolean} privateKeyFlag - private key flag
   */
  constructor(data = {}) {
    // eslint-disable-next-line no-multi-assign
    this.id = this._id = data._id;
    this.name = data.name || '';
    this.location = data.location || '';
    this.connection = data.connection || 'VNC';
    this.numberOfConnections = data.numberOfConnections || 1;
    this.acknowledgment = data.acknowledgment || 'No';
    this.hostname = data.hostname || '';
    this.port = data.port || 5900;
    this.localPort = data.localPort || 0;
    this.autoretry = data.autoretry || 1;
    this.swapRedBlue = data.swapRedBlue || false;
    this.cursor = data.cursor || '';
    this.readOnly = data.readOnly || false;
    this.username = data.username || '';
    this.password = data.password || '';
    this.type = data.type || '';
    this.privateKey = data.privateKey || '';
    this.securityMode = data.securityMode || '';
    this.ignoreServerCertificate = data.ignoreServerCertificate || false;
    this.privateKeyFlag = !!data.privateKey;
    this.serviceName = data.serviceName || '';
  }
}
